import React, { FC } from 'react';
import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';

interface CtaBannerProps {
  title?: string;
  subTitle?: string;
}

const CtaBanner: FC<CtaBannerProps> = ({ title, subTitle }) => {
  return (
    <Box
      bgGradient='linear-gradient(to bottom right, teal.600, brand.800)'
      color='fg.accent.default'
      borderRadius='xl'
      px={{ base: '6', lg: '16' }}
      py={{ base: '10', lg: '16' }}
      my={{ base: '8', lg: '16' }}
    >
      <Stack spacing='8' direction={{ base: 'column', lg: 'row' }} justify='space-between' alignItems='center'>
        <Stack spacing='4' maxW='2xl'>
          <Heading size='sm'>{title}</Heading>
          <Text color='fg.accent.muted' fontSize={{ base: 'lg', lg: 'xl' }}>
            {subTitle}
          </Text>
        </Stack>
        <Stack spacing='3' direction={{ base: 'column', sm: 'row' }} w={{ base: 'full', md: 'inherit' }}>
          <Button as={NextLink} href='/' variant='secondary.accent' size='xl' w='full'>
            Learn more
          </Button>
          <Button as={NextLink} href='/sign-up/' variant='primary.accent' size='xl' w='full'>
            Sign up for FREE
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CtaBanner;
